module.exports = __webpack_public_path__ + "fae5e7277b2273866682de344d0edf42.svg";